export default (state, prop1, prop2) => {
  if (prop1 && prop2) {
    return state.results &&
      state.results.filterBreakdown &&
      state.results.filterBreakdown[prop1]
      ? state.results.filterBreakdown[prop1][prop2]
      : 0;
  } else if (prop1) {
    return state.results &&
      state.results.filterBreakdown &&
      state.results.filterBreakdown[prop1]
      ? state.results.filterBreakdown[prop1]
      : [];
  }
};



// WEBPACK FOOTER //
// ./src/Common/getFilterBreakdownProp/index.js